var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 3.29346L4.03002 7.22346C2.10002 8.48346 2.10002 11.3035 4.03002 12.5635L10.05 16.4935C11.13 17.2035 12.91 17.2035 13.99 16.4935L19.98 12.5635C21.9 11.3035 21.9 8.49346 19.98 7.23346L13.99 3.30346C12.91 2.58346 11.13 2.58346 10.05 3.29346Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63 13.8435L5.62 18.5335C5.62 19.8035 6.6 21.1635 7.8 21.5635L10.99 22.6235C11.54 22.8035 12.45 22.8035 13.01 22.6235L16.2 21.5635C17.4 21.1635 18.38 19.8035 18.38 18.5335V13.8935",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 15.7634V9.76343",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.91dd0a4a.svg";
export { ForwardRef as ReactComponent };